import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import StageProgressBar from './StageProgressBar';
import QuestionResponses from './QuestionResponses';
import { Card } from '@mui/material';
import { useAuthContext } from '../../context/AuthProvider';
import { useLocation } from 'react-router-dom';
import GlobalStaging from './GlobalStaging';
import { ensureAbsoluteUrl } from '../../utility/ensureAbsoluteUrl';
import LinkView from '../ui/LinkView';
import IconWrapper from '../Cards/IconWrapper';
import { Check, ChevronDown, ChevronUp, X } from 'lucide-react';
import { hasPermission, PERMISSIONS } from '../../config/permissions.config';
// const stageComponents = {
//     Portfolio,
//     Screening,
//     'Design Task': DesignTask,
//     'Round 1': RoundOne,
//     'Round 2': RoundTwo,
//     Hired
// };
const AccordionSection = ({ title, isOpen, onToggle, children, badge }) => (
    <Card
        sx={{
            backgroundColor: "var(--color-background-100)",
            borderRadius: "0.75rem",
            marginTop: "0.75rem"
        }}
    >
        <div className="w-full">
            <button
                onClick={onToggle}
                className="w-full px-8 py-8 flex justify-between bg-background-100 items-center border-b border-background-100"
            >
                <div className="flex items-center gap-4 ">
                    <h3 className="text-font-main ">{title}</h3>
                    {badge}
                </div>
                <IconWrapper icon={isOpen ? ChevronUp :ChevronDown} size={0} customStrokeWidth={5} customIconSize={5}  />
            </button>

            {isOpen && (
                <div className="px-8 pb-8">
                    {children}
                </div>
            )}
        </div>
    </Card>
);

const getJobProfileKey = (jobApplied = '', fallbackProfile = '') => {
  const lower = jobApplied.toLowerCase();
  if (lower.includes('brand')) return 'Brand Designer';
  if (lower.includes('ui') || lower.includes('ux')) return 'UI UX';
  if (lower.includes('motion')) return 'Motion Designer';
  if (lower.includes('3d')) return '3D Designer';
  if (lower.includes('product')) return 'Product Designer';
  if (lower.includes('graphic')) return 'Graphic Designer';
  if (lower.includes('video')) return 'Video Editor';
  if (lower.includes('creative')) return 'Creative Director';
  return fallbackProfile || 'UI UX';
};

const ApplicationStaging = ({ candidateId, jobId ,jobStatus}) => {

    const { user } = useAuthContext();
    const location = useLocation();
    const role = location?.pathname?.startsWith('/candidate')
      ? 'Candidate'
      : (user?.role || 'Candidate'); // Default to Candidate if role is not specified

    const { currentStage, stageStatuses } = useSelector((state) => state.applicationStage);
    const candidateData = useSelector(state => state.candidate.candidateData);
    const [selectedStage, setSelectedStage] = useState(null);
    const [isQuestionsOpen, setIsQuestionsOpen] = useState(false);
    const stages = Object.keys(stageStatuses);

    useEffect(() => {
        setSelectedStage(currentStage);
    }, [currentStage]);
    // const renderStageComponent = (stage) => {
    //     const StageComponent = stageComponents[stage];
    //     if (!StageComponent) {
    //         console.warn(`No component found for stage: ${stage}`);
    //         return null;
    //     }
    //     const commonProps = {
    //         stageData: stageStatuses[stage],
    //         candidateId,
    //         jobId,
    //         isActive: stage === currentStage,
    //         isClosed : (jobStatus === "deleted" || jobStatus === "closed") 
    //     };
    //     return <StageComponent {...commonProps} />;
    // };
    const isStageVisible = (stage) => {
        const stageIndex = stages.indexOf(stage);
        const currentStageIndex = stages.indexOf(currentStage);
        return (
            stage === currentStage ||
            (stageIndex <= currentStageIndex && ['Cleared', 'Rejected'].includes(stageStatuses[stage]?.status))
        );
    };
    const getStageIcon = (stage, index) => {
        const status = stageStatuses[stage]?.status;
        if (status === 'Cleared') {
            return <div className='bg-accent-100 rounded-full text-white p-1'><IconWrapper inheritColor icon={Check}  size={0} customStrokeWidth={7} customIconSize={1}  /></div> ;
        } else if (status === 'Rejected') {
            return <div className='bg-red-300 rounded-full text-white p-1'><IconWrapper inheritColor icon={X}  size={0} customStrokeWidth={7} customIconSize={1}  /></div> ;
        } else {
            return (
                <div className={`w-6 h-6 flex items-center justify-center rounded-full border  ${stage === currentStage ? 'border-accent-100 text-font-accent' : ' border-font-gray'}`}>
                    {index + 1}
                </div>
            );
        }
    };
    const visibleStages = stages.filter(isStageVisible);
    if (!stages.length) {
      
        return <div>No stages available. Please check the candidate data.</div>;
    }
    const renderQuestionResponses = () => {
        const responses = candidateData?.jobApplication?.questionResponses;

        if (!responses || responses.length === 0) {
            return (
                <div className="text-center text-font-gray">
                    No question responses available
                </div>
            );
        }

        return (
            <div className="">
                {responses.map((response, index) => (
                    <div
                        key={response.questionId}
                        className={`  rounded-lg ${index !== (responses?.length - 1) ? 'pb-6' : ''}`} 
                    >
                        <div className="flex items-start gap-4">
                            <div className="flex-shrink-0  h-6  flex items-center justify-center">
                                <span className="text-sm ">{index + 1}</span>
                            </div>
                            <div className="flex-1 space-y-2">
                                <div className="typography-body ">
                                    {response.question.text}
                                    {response.question.required && (
                                        <span className="ml-1 text-red-500">*</span>
                                    )}
                                </div>
                                <div className="typography-body text-font-main">
                                    {response.question.type === 'multiple' ? (
                                        <div className="flex gap-2">
                                            <span className="px-3 py-1 ">
                                                {response.answer}
                                            </span>
                                        </div>
                                    ) : response.question.type === 'multi-select' ? (
                                        <div className="flex gap-2">
                                            <ul className="px-3  list-disc flex flex-col gap-2 ">
                                                {
                                                    response.answer?.length > 0 && response.answer.map(ans =><li>{ans}</li>)
                                                }
                                            </ul>
                                        </div>
                                    ) : (
                                        <div className="bg-background-80 p-3 rounded-lg">
                                            {response.question.answerType === 'link' ? (
                                                <LinkView url={response.answer} text="View Link"/>
                                                                                       
                                            ) : (
                                                <span>{response.answer}</span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="application-staging">
            <h4 className="mb-4">Application Stages</h4>

            {/* Stage Progress Section */}
            <div className="stages-progress flex">
                {stages.map((stage, index) => (
                    <React.Fragment key={stage}>
                        <div
                            className={`stage-item flex typography-body flex-col gap-2 justify-center items-center ${isStageVisible(stage) ? ' cursor-pointer  ' : ' cursor-default opacity-50'}`}
                            onClick={() => isStageVisible(stage) && setSelectedStage(stage)}
                        >
                            <div className="stage-icon">
                                {getStageIcon(stage, index)}
                            </div>
                            <div className={`stage-name mb-2 typography-body ${stage === currentStage ? "text-font-accent cursor-pointer " : "text-font-main "}  `}>
                                {stage}
                            </div>
                        </div>
                        {index < stages.length - 1 && (
                            <div className="progress-bar flex-grow mx-2 flex justify-center">
                                <StageProgressBar
                                    stage={stage}
                                    status={stageStatuses[stage]?.status}
                                    isActive={stage === currentStage}
                                />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>

            {/* Stage Content */}
            <div className="stages-content mt-4">
                <GlobalStaging 
                role={role} 
                selectedStage={selectedStage} 
                stageStatuses={stageStatuses} 
                jobProfile={getJobProfileKey(
                  candidateData?.jobApplication?.jobApplied,
                  candidateData?.jobApplication?.jobProfile
                )} 
                isClosed={(jobStatus === "deleted" || jobStatus === "closed")}
                />
            </div>

            {/* Question Responses Accordion */}

            {
                hasPermission(role,PERMISSIONS.SHOW_ADDITIONAL_QUESTIONS) && (

                    <AccordionSection
                        title="Additional Questions"
                        isOpen={isQuestionsOpen}
                        onToggle={() => setIsQuestionsOpen(!isQuestionsOpen)}
                        badge={
                            <span className="typography-small-p text-font-gray">
                                {candidateData?.jobApplication?.questionResponses?.length || 0} Questions
                            </span>
                        }
                    >
                        {renderQuestionResponses()}
                    </AccordionSection>

                )
            }
        </div>
    );
};

export default ApplicationStaging;
